import React from 'react';

export interface EmptyStateProps {
  readonly heading?: string;
  readonly body?: string;
}

/**
 * Rendered when the source resolved successfully but the iteration
 * array is empty (post-`iteratorPath`). DSL authors may set
 * `emptyStateText` on the repeater to override the body copy; the
 * heading defaults to the SAD-canonical "No results" so screen
 * readers always have an unambiguous landmark.
 *
 * Wrapped in a `region` landmark with `aria-labelledby` so AT users
 * can land directly on the empty state from the rotor.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  heading = 'No results',
  body = 'Try adjusting your filters and search again.',
}) => (
  <section
    aria-labelledby='data-repeater-empty-heading'
    data-testid='data-repeater-empty'
    style={{ padding: 24, textAlign: 'center' }}
  >
    <h3
      id='data-repeater-empty-heading'
      style={{ margin: 0, fontSize: 18, fontWeight: 600 }}
    >
      {heading}
    </h3>
    <p style={{ marginTop: 8, marginBottom: 0, color: 'rgba(0,0,0,0.65)' }}>
      {body}
    </p>
  </section>
);
